module.exports = __webpack_public_path__ + "img/151.adaa067e.jpg";